import React from 'react'
import { webinarLinkTo } from 'event-taxonomy'
import WebinarSingle from './WebinarSingle'

const WebinarCollection = (props) => {
  let { collection } = props

  collection = (
    collection.map((single, index) => {
      return (
        <WebinarSingle
          key={index}
          to={webinarLinkTo(single)}
          type={single.type}
          title={single.title}
          start={single.start_at}
          facilitator={single.facilitator}
        />
      )
    })
  )

  return (
    <div>
      {collection}
    </div>
  )
}

WebinarCollection.propTypes = {
  collection: React.PropTypes.array.isRequired
}

export default WebinarCollection
